export function alphanumeric(value: string) {
  return value.replace(/\W/g, '');
}
